import { render, staticRenderFns } from "./AresDialog.vue?vue&type=template&id=291bd696&scoped=true&"
import script from "./AresDialog.vue?vue&type=script&lang=ts&"
export * from "./AresDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291bd696",
  null
  
)

export default component.exports